import React, { Fragment, useEffect, useRef, useState } from "react";
import env from '../../../env';
import useSort from '../../../hooks/useSorting';
import Cs from "../../../services/CommonService";
import { useCurrentUserHook } from "../../Authentication/useUserHook";
import { LinkDeleteIcon, LinkFontAwesomeIcon } from "../../Common/ImageIcons";
import PaginationSM from '../../Common/PaginationSM';
import SortDirection from '../../Common/SortDirection';
import { Spinner } from "../../Common/Spinner";
import { Table, TBody, TD, TH, THead, TR } from "../../Common/TableView";
import ActivityService from "./ActivityService";
import useModal from "../../../hooks/useModal";
import CommentsModal from "../../Modals/CommentsModal";
import FormTemplateService from "../../../services/FormTemplateService";
import {OptionsObjList} from '../../Common/FormInput';
import DataSourceService from "../../../services/DataSourceService";
import GenericModal from "../../Modals/GenericModal";
import ActivityCard from './ActivityCard';
import ActivityForm from "./ActivityForm";
import ConfirmMenu from "../../Modals/ConfirmMenu";
import DynamicTable from '../../Common/DynamicTable';
import { NavIcon } from '../../Common/MenuItem';

const ActivityListTable = (props) => {
  let { current: scope } = useRef({ requestParams: {} });
  const { currentUser } = useCurrentUserHook();

  const {journeyProfile, searchString, componentName, tabDsItem, activityReloadTab} = props;
  const {form_id:formId, sid} = tabDsItem;

  const [loading, setLoading] = useState(true);
  const [list, setList] = useState([]);
  const [pagemeta, setPagemeta] = useState({});
  const [formFields, setFormFields] = useState([]);
  const [dataSource, setDataSources] = useState({});
  const [filter, setFilter] = useState({});

  const {isOpen:isCommentOpen, toggleModal:toggleCommentModal} = useModal();
  const {isOpen:isCardOpen, toggleModal:toggleCardModal} = useModal();
  const {isOpen:isFormOpen, toggleModal:toggleFormModal} = useModal();
  const {isOpen: isDeleteOpen, toggleModal: toggleDeleteModal } = useModal();
  
  useEffect(() => {
    setParams(1);
    getAll();
  }, [props.searchString, filter])

  useEffect(() => {
    getFormFields();
    getDsLocale();
  }, [])

  const setParams = (page) => {
    scope.requestParams = {
      'page': page,
      'paginate': 1,
      'per_page': 15,
      'sort_column': scope.requestParams.sort_column || 'updated_at',
      'sort_direction': scope.requestParams.sort_direction || 'desc',
      'search': props.searchString,
      'organization_id':currentUser.current_organization_id,
      'journey_profile_id': journeyProfile.id,
      'filter': filter,
      'form_type': sid
    }
  }

  const onPageChage = (page) => {
    setParams(page);
    getAll();
  }

  const getAll = async () => {
    setLoading(true);
    const { status, data } = await ActivityService.getAll(scope.requestParams);
    if (status == 200) {
      setList(data.activities);
      setPagemeta(data.meta);
      setLoading(false);
    }
  }

  const { sort } = useSort(scope.requestParams, getAll);

  let getFormFields = () => { 
    FormTemplateService.getFormFields({
      'ids':[formId] 
    }).then((res)=>{
      if(res.status === 200){
        setFormFields(res.data.form_fields[formId]);
        setLoading(false);
      }
    })
  }

  const getDsLocale = async () =>{
    setLoading(true);
    const data = await DataSourceService.getDataSource({
      'data_source_params':{
        'data_source_id':[3886, 4775],
        'locale':currentUser.current_locale
      }
    })

    if(data){
      setDataSources(data);
      setLoading(false);
    }
  }

  const deleteActivity = async () => {
    setLoading(true);
    const { status } = await ActivityService.delete(scope.selectedActivity.id);
    if (status === 204) {
      setList(list.filter(i => i.id !== scope.selectedActivity.id));
    }
  
    setLoading(false);
    toggleDeleteModal();
  };
  
  const onDelete = (activity) => {
    scope.selectedActivity = activity;
    toggleDeleteModal();
  }
  
  const addComments = (activity) => {
    scope.selectedActivity = activity;
    toggleCommentModal();
  }

  const updateStatus = async (idx, activity) => {
    setLoading(true);
    const { status } = await ActivityService.update(activity);
    if (status === 204) {
      list[idx].status = activity.status;
      setList([...list]);
    }
    setLoading(false);
  }

  const openActivityCard = (activity) =>{
    scope.selectedActivity = activity;
    toggleCardModal();
  }
  
  const openActivityFormModal = (activity) => {
    scope.activityFormProps = {
      'match':{
        'params':{
          'id': activity?.id,
          'form_id': formId,
          'form_type': tabDsItem?.sid,
          'form_dsl_id': tabDsItem?.pk_id,
          'journey_profile_id': journeyProfile.id
        }
      },
      'isPopupMode':true,
      'editactivity':activity,
      'onSubmit':onSubmit
    }
    toggleFormModal();
  }

  const onSubmit = (activity) =>{
    const filteredList = list.filter(n => n.id !== activity.id);
    if(activity)setList([activity, ...filteredList]);
  }

  const SortDirIco = ({ column }) => {
    return (
      <SortDirection sortColumn={scope.requestParams.sort_column}
      column={column} reverse={scope.requestParams.reverse} />
    )
  }

  const StatuDropDown = ({id, status, index}) => (
    <select className="form-control input-sm fw500 w-200" 
      onChange={(e)=>updateStatus(index, {'id':id, 'status':e.target.value})} 
      placeholder="Status" defaultValue={status}>
        <option value="">None</option>
        <OptionsObjList list={dataSource.status?.options} 
        idKey='sid' labelKey='label' userLocale={currentUser.current_locale}/>
    </select>
  )

  const OptionsEle = ({item}) => (
    <td>
      <div className="flex coldir aligncenter rgap-5 pointer">
        <LinkFontAwesomeIcon
          tooltip="Edit"
          onSelect={() => openActivityFormModal(item)}
          iconCss="fas fa-pen white"/>
            
        <LinkFontAwesomeIcon
          tooltip="Add Comments"
          onSelect={() => addComments(item)}
          iconCss="fas fa-comments white" />
            
        <LinkDeleteIcon id="delete_activity" 
          tooltip="Delete activity" 
          onSelect={() => onDelete(item)} />
      </div>  
    </td>
  )

  const recordId = (clientId, data, row) => {
    return (
      <span onClick={()=>openActivityCard(row)}>{row.record_id}</span>
    )
  }

  const date = (clientId, data, row) => {
    return <>{Cs.formatUpdateDate(row.updated_at, 'MMM D YYYY')}</>;
  }

  const specialFields = [
    {label:"ID", client_id:'record_id', ele:recordId}
  ]
    
  const specialFieldsLastCol = [
    {label:"Date", client_id:'updated_at', ele:date}
  ]

  return (
      <div id="ct">
        <div className="p10">
          <div className="app-header flex justspacebetween">
            <div className="flex coldir">
              <div className="font-15 m-t-2">
                Total - {pagemeta.total} | Page - {pagemeta?.current_page}/{pagemeta?.last_page}
              </div>
            </div>
            <div className="flex aligncenter">
              <NavIcon id="new_action" dataTip="Create New Event" 
                className="bg-highlight round-btn m-r-5" 
                icon="fas fa-plus"
                onSelect={()=>openActivityFormModal()}/>
            </div>
          </div>

          {loading ? <Spinner /> : null}

          <div className="p10 m-t-10 table-fix-head">
            <DynamicTable
              requestParams={{}}
              formFields={formFields}
              formDataList={list}
              tClass="table"
              OptionsEle={OptionsEle}
              specialFields={specialFields} 
              specialFieldsLastCol={specialFieldsLastCol}
            />
          </div>
          <PaginationSM
            className="pagination-bar"
            currentPage={parseInt(pagemeta.current_page)}
            totalItems={pagemeta.total}
            itemsPerPage={pagemeta.per_page}
            onPageChange={onPageChage}
            siblingCount={2} />
        </div>

        {isCommentOpen && 
          <CommentsModal 
            isOpen={isCommentOpen} 
            toggleModal={toggleCommentModal} 
            item={scope.selectedActivity} 
            type="activity"/>
        }

        {isCardOpen &&
          <GenericModal
            component={ActivityCard}
            isOpen={isCardOpen}
            toggleModal={toggleCardModal}
            activity={scope.selectedActivity}
            formFields={formFields}
            addComments={addComments}
            onDelete={onDelete}
            currentUser={currentUser}/>
        }

        {isFormOpen && 
          <GenericModal 
            component={ActivityForm}
            isOpen={isFormOpen} 
            toggleModal={toggleFormModal} 
            {...scope.activityFormProps}/>
        }

        <ConfirmMenu isOpen={isDeleteOpen} 
          toggleModal={toggleDeleteModal} 
          success={() => deleteActivity(scope.selectedActivity)}/>

      </div>
  )

}

export default ActivityListTable;